'use strict'

module.exports = class BrowseRelatedModel extends Backbone.Model
  url: '/browse/search/related'
